export default __webpack_public_path__ + "static/emailconfirmed-3b69b0705c9f71bda5bbd550e7cc085d.gif";